import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import cn from 'classnames';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';
import { NavLink as Link } from 'react-router-dom';
import Utils from '../shared/util.js';
import { PrimaryButton, SecondaryButton, RoundButton } from '../ui-toolkit/buttons.js';
import FormattedNumberCurrency from '../shared/formattedNumberCurrency.component.js';
import ContactsService from '../../features/contacts/contacts.service.js';
import messageIcon from '../../assets/images/contacts-messages/send-message.svg';

import './sticky-solver-challenge-details-card.scss';

const openAnonymousChat = (challengeId, intl, history) => {
	ContactsService.openAnonymousChat(challengeId)
		.then((chatId) => {
			history.push(`/messages/${chatId}`);
		})
		.catch((error) => {
			Utils.showErrorMessageAlert(error, toast.TYPE.ERROR, intl);
		});
};

const StickySolverChallengeDetailsCard = ({
	id,
	title,
	award,
	date,
	show,
	hide,
	intl,
	history,
}) => (
	<div
		className={cn('sticky-solver-challenge-card', {
			show,
			hide,
		})}
	>
		<div
			className="sticky-solver-challenge-card-content
										d-md-flex align-items-center justify-content-between"
		>
			<div>
				<h1>{title}</h1>

				{award && (
					<RoundButton className="prize d-none d-md-inline-block" primary>
						<FormattedNumberCurrency number={award.amount} currency={award.currencyCode} />
					</RoundButton>
				)}

				{date && (
					<RoundButton className="date d-none d-md-inline-block">
						<i className="material-icons">access_time</i>
						{date}
					</RoundButton>
				)}
			</div>


			<div className="buttons-wrapper">
				<SecondaryButton fullWidth className="message-button" onClick={() => openAnonymousChat(id, intl, history)}>
					<img src={messageIcon} alt="" />

					<FormattedMessage id="solver_challenge_card.send_message" />
				</SecondaryButton>

				<Link to={`/challenges/${id}/solution/submit-solution`} className="submit-solution-link">
					<PrimaryButton>
						<FormattedMessage id="solver_challenge_card.submit_solution" />
					</PrimaryButton>
				</Link>
			</div>

		</div>
	</div>
);

export default withRouter(injectIntl(StickySolverChallengeDetailsCard));
